import React from "react";
import BlogItem from "../pages/blogItem";

const Blog = () => {
  const posts = [
    {
      title: "Github Finder",
      contentTitle: "Font end React App",
      img: [
        "https://i.imgur.com/xAsRfJt.png",
        "https://i.imgur.com/T3NC2o1.png"
      ],
      content:
        "React app to search Github profiles. This app uses the Context API along with the useContext and useReducer hooks for state management.Responsive App and Hooks",
      link: ["https://githubfinder57416.netlify.com/"],
      repolink: "https://github.com/lbeatu/Github-Finder-With-Hooks"
    },
    {
      title: "Electro Mobil UI",
      contentTitle: "C# Winforms Application ",
      img: ["https://i.hizliresim.com/odlzL9.png"],
      content:
        "C# Winforms Xbee Communication-UART communication with Baudrate and serial port application for Electrial which is TÜBİTAK Efficiency Challenge Electric Vehicle TR ADD-ONS :Syncfusion Lineer and Radial Gauge.Bunifu v1.5.4 and metro Uİ.One more .",
      link: "",
      repolink: "https://github.com/lbeatu/Electro-Mobil-UI"
    },
    {
      title: "Movifavo • MERN App ",
      contentTitle: "MERN Full Stack App +OMDB Api",
      img: ["https://i.imgur.com/Gqyeoio.png"],
      content:
        "his project was made with with the famous Front-End framework React Js. The Express JS backend framework(https://expressjs.com) is used for auth and CRUD operations.MongoDb keeps the user data(https://www.mongodb.com) and JSON Web Tokens for authentication(https://jwt.io).Movie Database is The OMDb API is a RESTful web service to obtain movie information,all content and images on the site are contributed and maintained by our users.Link(http://www.omdbapi.com/)",
      link: "https://sheltered-falls-57741.herokuapp.com/",
      repolink: "https://github.com/lbeatu/movifavo"
    },
    {
      title: "TODO List • Android App",
      contentTitle: "Mobile App",
      img: [
        "https://i.ibb.co/KxDFSPL/Whats-App-Image-2019-12-18-at-21-32-18.jpg"
      ],
      content:
        "Mydoes Android Project backend:https://firebase.google.com/.Add your to do works ,applications ,hobbies and anything update and delete.Save from Google firebase ",
      link: "https://github.com/lbeatu/TODO-List-on-Android",
      repolink: "https://github.com/lbeatu/TODO-List-on-Android"
    }
  ];

  return (
    <div className="blog-container">
      {posts.map(posts => (
        <BlogItem key={posts.id} posts={posts} />
      ))}
    </div>
  );
};

export default Blog;
